import { render, staticRenderFns } from "./ShProductBox.vue?vue&type=template&id=7a8ae7f2&scoped=true&"
import script from "./ShProductBox.vue?vue&type=script&lang=js&"
export * from "./ShProductBox.vue?vue&type=script&lang=js&"
import style0 from "./ShProductBox.vue?vue&type=style&index=0&id=7a8ae7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ae7f2",
  null
  
)

export default component.exports